import Encoding from 'encoding-japanese';

export const ReadCSV = (file) => {
    return new Promise((resolve, reject) => {
        //fileReaderを初期化
        var fileReader = new FileReader();

        // エラーハンドリング
        fileReader.onerror = (e) => {
            reject(new Error("ファイルの読み込みに失敗しました"));
        };

        //ロード完了時のイベントハンドラに後処理を登録
        fileReader.onload = (e) => {
            try {
                // SJIS から UTF-8 に変換
                let utf8Array = Encoding.convert(fileReader.result, {
                from: 'SJIS',
                to: 'UNICODE',
                type: 'string',
                });

                // CSV を配列に変換
                let csvRowList = ConvertCSVToArray(utf8Array);

                // 成功時に csvRowList を resolve で返す
                resolve(csvRowList);
            } catch (error) {
                reject(error); // 変換に失敗した場合にエラーを返す
            }
        };

        // テキストとしてファイルを読み込む
        fileReader.readAsBinaryString(file);
    });
};

export const ConvertCSVToArray = (utf8Array) => {
    // 改行文字を統一して行ごとに分割
    let csvArray = utf8Array.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');

    // 返却配列を取得
    let returnArray = [];

    // 文字列の配列に対してループ処理
    csvArray.forEach((csvString, arrayIndex) => {
        // タイトル行は除いて処理する
        if (arrayIndex > 0 && csvString !== "") {
        // 文字列を分割
        let rowArray = csvString.split(',');

        rowArray = rowArray.map((data) => data.replace('"', '').replace('"', ''));

        // 返却配列に追加
        returnArray.push(rowArray);
        }
    });

    return returnArray;
};
